import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { api, endpoints } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, CalendarDays, Clock } from "lucide-react";

const fmt = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

export const LatestNews = ({ limit = 6 }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(endpoints.posts).then(setItems).catch(() => {}); }, []);
  const list = items.slice(0, limit);
  return (
    <section id="news" className="surface-tint">
      <div className="container-wide py-16 lg:py-24">
        <div className="flex items-end justify-between gap-6 mb-8 lg:mb-12">
          <SectionHeader eyebrow="Latest News" title="From the field, in the last 3 months." lead="Dated updates from our newsroom, programs and finance teams." />
          <Link to="/blog" className="hidden md:inline-flex items-center gap-1 text-sm font-medium text-[hsl(var(--navy))] link-underline">All news <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {list.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.04}>
              <Link to={`/blog/${p.slug}`} className="group block rounded-xl border border-[hsl(var(--border))] bg-card overflow-hidden card-lift focus-ring" data-testid={`blog-card-${p.slug}`}>
                <div className="aspect-[16/9] overflow-hidden">
                  <img loading="lazy" src={p.cover_image} alt={p.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2"><Badge className="badge-navy border">{p.category}</Badge><span className="text-xs text-[hsl(var(--muted-ink))] inline-flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" /> {fmt(p.published_at)}</span></div>
                  <h3 className="heading-3 mt-3 text-lg group-hover:text-[hsl(var(--orange))]">{p.title}</h3>
                  <p className="text-sm text-[hsl(var(--muted-ink))] mt-2 line-clamp-3">{p.excerpt}</p>
                  <div className="mt-4 text-xs text-[hsl(var(--muted-ink))] inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {p.read_min} min read</div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        <div className="md:hidden mt-6"><Link to="/blog" className="inline-flex items-center gap-1 text-sm font-medium text-[hsl(var(--navy))] link-underline">All news <ArrowRight className="h-4 w-4" /></Link></div>
      </div>
    </section>
  );
};
